// extracted by mini-css-extract-plugin
export var fileExt = "_sv-8";
export var fileIcon = "_sv-6";
export var fileLink = "_sv-5";
export var fileName = "_sv-7";
export var image = "_sv-1";
export var imageError = "_sv-3";
export var imageErrorIcon = "_sv-4";
export var imageLink = "_sv-0";
export var imageLoaded = "_sv-2";